var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum3Gray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3086,
    cy: 16.8828,
    r: 16,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0021 23.0928C14.2471 23.0928 13.0621 22.4328 12.2821 21.5478L13.3171 20.1528C13.9771 20.7978 14.7871 21.2928 15.7921 21.2928C16.9171 21.2928 17.6821 20.7378 17.6821 19.7328C17.6821 18.6528 17.0371 17.9628 14.6221 17.9628V16.3878C16.6621 16.3878 17.3221 15.6828 17.3221 14.6928C17.3221 13.8228 16.7821 13.3128 15.8371 13.3128C15.0421 13.3128 14.3971 13.6728 13.7371 14.2878L12.6121 12.9378C13.5721 12.0978 14.6371 11.5728 15.9421 11.5728C18.0871 11.5728 19.5421 12.6378 19.5421 14.5278C19.5421 15.7278 18.8671 16.5978 17.6971 17.0628V17.1378C18.9421 17.4828 19.9021 18.4128 19.9021 19.8678C19.9021 21.9078 18.1171 23.0928 16.0021 23.0928Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum3Gray);
export default __webpack_public_path__ + "static/media/icon_circleNum_3_gray.3bbbf99863c47348ffd94ccf5dbac3ed.svg";
export { ForwardRef as ReactComponent };